<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <transition name="opacity">
    <div v-if="isVisible" :class="b()" @click.self="handleClose">
      <div :class="b('wrapper')" v-click-outside="handleClose">
        <button :class="b('close')" @click="handleClose">
          <span :class="b('close-icon')" v-html="displayedCloseIcon"></span>
        </button>

        <div :class="b('content')">
          <div :class="b('instructions')">
            <h3 :class="b('title')">
              {{ $t("Пожалуйста, сделайте селфи, ориентируясь на пример.") }}
            </h3>

            <ul :class="b('list')">
              <li :class="b('item')">
                {{ $t("На фотографии должно быть чётко видно ваше лицо целиком — лоб, глаза, нос и подбородок не должны быть обрезаны или закрыты.") }}
              </li>
              <li :class="b('item')">
                {{ $t('В одной руке держите документ, выбранный на предыдущем шаге (паспорт, ID ), так чтобы было видно фото и основные данные.') }}
              </li>
              <li :class="b('item')">
                {{ $t('В другой руке держите лист бумаги, на котором от руки написаны текущая дата, текст LLC "MEX" и ваша подпись.') }}
              </li>
              <li :class="b('item')">
                {{ $t("Лицо, документ и лист с текстом должны быть одновременно в одном кадре.") }}
              </li>
              <li :class="b('item')">
                {{ $t("Фото должно быть сделано при хорошем освещении, без теней и затемнений.") }}
              </li>
              <li :class="b('item')">
                {{ $t("Избегайте бликов на документе — данные должны быть читаемы.") }}
              </li>
              <li :class="b('item')">
                {{ $t("Не используйте фильтры, маски, ретушь или портретный режим камеры.") }}
              </li>
              <li :class="b('item')">
                {{ $t("Фотография должна быть резкой, без смаза и следов редактирования.") }}
              </li>
              <li :class="b('item')">
                {{ $t("Скриншоты, коллажи и фотографии с экрана не принимаются.") }}
              </li>
            </ul>
          </div>

          <div :class="b('example')">
            <img
              :class="b('example-image')"
              :src="exampleImageSrc"
              alt="Пример селфи с паспортом"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
